import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import apiService from '../_services/PreMatriculaService'

const state = {
  loading: false,
  loadingStore: false,
  prematricula: undefined,
  erros: '',

}

const getters = {
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

}

const actions = { 

  UPDATE_CONTACTED : async ({ commit },{ id, status }) => {
    return new Promise(async (resolve, reject) => {

      console.log('UPDATE_CONTACTED')
      console.log(`id: ${id}`)
      console.log(`status: ${status}`)

      commit('ERASE_ERROS')
      try {
        commit('SET_LOADING_STORE', true)
        var response = await apiService.putPreMatriculaContacted(id, status)

        if (response.data.status) {
          resolve(response.data.prematricula)
        } else if (!response.data.status && response.data.validacao) {
          var erros = erroArrayToString(response.data.erros)
          commit('SET_ERROS', { erros: erros })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }

      } catch (error) {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      } finally {
        commit('SET_LOADING_STORE', false)
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/PreMatricula/_store/index.js